import React from "react";
import { Link } from "gatsby";

const imagePath = "/assets/marketing-site/images";

export default function HelpfulFirstStep({
	dark = false,
	phoneNumber = "020 3970 9900",
	phoneHref = "tel:02039709900",
}) {
	return (
		<section
			className={`approach-reassurance section-space ${
				dark ? "approach-reassurance--dark" : ""
			}`}
		>
			<div className="site-shell approach-reassurance__inner">
				<div
					className="approach-reassurance__advisors"
					role="img"
					aria-label="Daniel Greeves and Matthew McCloskey, Edyn Family Care Advisors"
				>
					<img src={`${imagePath}/team/daniel-new.png`} alt="" loading="lazy" />
					<img src={`${imagePath}/team/matthew.png`} alt="" loading="lazy" />
				</div>
				<p className="eyebrow">A helpful first step</p>
				<h2>You do not need to have everything worked out.</h2>
				<p>
					Tell us what is happening now. A Family Care Advisor can help you
					understand the options, likely timescales and what to do next.
				</p>
				<div className="button-row">
					<Link
						className={`button ${dark ? "button--cream" : "button--primary"}`}
						to="/care-consultation/"
					>
						Arrange a call
					</Link>
					<a className="button button--text" href={phoneHref}>
						Call {phoneNumber}
					</a>
				</div>
			</div>
		</section>
	);
}
